import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { WuiPreviewTableComponent } from 'wflow-ui';
import { DocumentVAT } from 'wflow-main-app/src/app/core/api/model/documents/detail-document';

@Component({
  selector: 'wf-peppol-ubl-preview-vat-recap',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, TranslateModule, WuiPreviewTableComponent],
  templateUrl: './peppol-ubl-preview-vat-recap.component.html',
})
export class PeppolUblPreviewVatRecapComponent {
  readonly vats = input.required<DocumentVAT[]>();
}
